import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'

type Props = {
  dataCy?: string
  isFilled: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onClick: () => void
  placeholder: string
  value: string
}

const SearchForm: FC<Props> = React.memo((props) => {
  const { dataCy, isFilled, onChange, onClick, placeholder, value } = props

  const dataCyInput = dataCy ? `search-form-input-${dataCy}` : 'search-form-input'
  const dataCyButton = dataCy ? `search-form-button-${dataCy}` : 'search-form-button'

  return (
    <div className={styles.search}>
      {!isFilled && <img className={styles.search__icon} src={'/icon/grey/search.svg'} alt={'検索'} />}
      <input
        className={isFilled ? styles.search__input_filled : styles.search__input}
        data-cy={dataCyInput}
        placeholder={placeholder}
        onChange={(e) => onChange(e)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onClick()
          }
        }}
        type={'text'}
        value={value}
      />
      <button
        className={isFilled ? styles.search__button_filled : styles.search__button}
        data-cy={dataCyButton}
        onClick={onClick}
      >
        検索
      </button>
    </div>
  )
})

export default SearchForm
